import React, { useEffect, useState } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { CircularProgress } from "@material-ui/core";
import { invokeApi } from "../../bl_libs/invokeApi";
import {
  googleBtnImage,
  facebookBtnImage,
  greyBackArrowImage,
} from "../../assets";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";
import GoogleAuth from "./components/GoogleAuth";
import FacebookAuth from "./components/FacebookAuth";
import PhoneNumberScreen from "./components/PhoneNumberScreen";
function LoginPage(props) {
  // if it comes from new request screen-------------------------
  const { reqPostData, setConfirmScreen, isDirectRequest } = props;
  //--------------------------------------------------------------
  const [errMessage, setErrMessage] = React.useState("");

  const { socketON, socketOFF } = useSockets();
  const [isLoading, setIsLoading] = React.useState(false);

  //auth flag
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [auth, setAuth] = useState();
  const [openPhoneNumberScreen, setOpenPhoneNumberScreen] =
    React.useState(false);

  const [inputs, setInputs] = React.useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setInputs({
      ...inputs,
      [e.target.id]: e.target.value,
    });
  };
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  // Post client request before entering in app
  const handleReqPostData = (token, user) => {
    let requestObj = {
      path: "/api/customer/generate_request",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = reqPostData;
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        socketON();
        props.history.push("/dashboard/congratulations");
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //validations step for email
    if (!validateEmail(inputs.email)) {
      setErrMessage("Please enter a valid email");
      return;
    }
    //validations step for password
    if (inputs.password.length < 6) {
      setErrMessage("Minimum 6 characters required for password");
      return;
    }
    let requestObj = {
      path: "/app_api/login",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: inputs.email,
      password: inputs.password,
      user_type: "1",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res, "LOGIN");
        if (reqPostData) {
          handleReqPostData(res.data.auth_token, res.data.user);
          return;
        }
        localStorage.setItem("token", res.data.auth_token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        socketON();
        props.history.push("/dashboard");
      } else {
        // setErrMessage(res.message);
        if (res.message === "Invalid Email or Password") {
          setErrMessage(
            "The email and password you entered did not match our records."
          );
        }
        setIsLoading(false);
        setIsAuthenticated(false);
        localStorage.clear();
        console.log(res);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  console.log(props, "LOGIN PROPS");
  if (localStorage.getItem("token")) {
    return <Redirect to="/dashboard"></Redirect>;
  }
  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress">
          <CircularProgress />
        </div>
      </>
    );
  }
  if (openPhoneNumberScreen) {
    return (
      <PhoneNumberScreen
        auth={auth}
        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
        handleReqPostData={handleReqPostData}
        reqPostData={reqPostData}
      />
    );
  }
  return (
    <section className="main-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-0 col-md-3 col-xl-4"></div>
          <div className="col-12 col-md-6 col-xl-4">
            {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )}

            {reqPostData && (
              <Alert variant="filled" severity="info">
                Your moving request has been saved. Please sign up or log into
                your account.
                {/* <span className="pointer-point custom-link text-black pl-2">
                  Edit?
                </span> */}
              </Alert>
            )}
            <div className="form-box-wrapper">
              <div className="form-box">
                <h5 className="text-center">Log In</h5>
                <div className="social-login-wrapper pt-sm-3">
                  <div className="row justify-content-center text-center">
                    <div className="col-6 text-right p-0">
                      <GoogleAuth
                        setIsLoading={setIsLoading}
                        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
                        setAuth={setAuth}
                        handleReqPostData={handleReqPostData}
                        reqPostData={reqPostData}
                      />
                    </div>
                    <div className="col-6 text-left p-0">
                      <FacebookAuth
                        setIsLoading={setIsLoading}
                        setOpenPhoneNumberScreen={setOpenPhoneNumberScreen}
                        setAuth={setAuth}
                        handleReqPostData={handleReqPostData}
                        reqPostData={reqPostData}
                      />
                    </div>
                  </div>
                  <div className="row text-center justify-content-center">
                    <div className="col-11 col-sm-9">
                      <div className="small-text-bold dark-grey-color text-divider">
                        <span>OR</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="evom-form login-form">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label
                        htmlFor="email"
                        className="overline dark-grey-color"
                      >
                        Email
                      </label>
                      <input
                        required
                        value={inputs.email}
                        onChange={handleChange}
                        type="email"
                        className="form-control small-font-size"
                        id="email"
                        placeholder="example@gmail.com"
                      />
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="email"
                        className="overline dark-grey-color"
                      >
                        Password
                      </label>
                      <input
                        required
                        value={inputs.password}
                        onChange={handleChange}
                        type="password"
                        className="form-control small-font-size"
                        id="password"
                        placeholder="*********"
                      />
                    </div>
                    <div className="form-group">
                      <p className="text-right">
                        <Link
                          to="/forget-password"
                          className="caption dark-grey-color underline-text"
                          target={reqPostData ? "_blank" : ""}
                        >
                          Forgot password?
                        </Link>
                      </p>
                    </div>
                    <div className="form-group button-wrapper">
                      <button
                        type="submit"
                        className="custom-buton custom-buton-large w-100"
                      >
                        Log In
                      </button>
                    </div>
                    <div className="no-account-text-wrapper-custom text-center mt-4 pt-4 ">
                      <p className="light-grey-color">
                        Don't have an account?{" "}
                        {reqPostData ? (
                          <Link
                            onClick={() => setConfirmScreen("signup")}
                            className="dark-grey-color"
                          >
                            Sign Up
                          </Link>
                        ) : (
                          <Link
                            to={{
                              pathname: "/register",
                              state: reqPostData,
                            }}
                            className="dark-grey-color"
                          >
                            Sign Up
                          </Link>
                        )}
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-0 col-md-3 col-xl-4"></div>
        </div>
        <div className="no-account-text-wrapper-custom text-center mt-4 pt-4 mt-sm-5 pt-sm-5"></div>
      </div>
      {reqPostData && (
        <div className="next-prev">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-7 col-md-4">
              <div className="float-left">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setConfirmScreen("")}
                  className="dark-grey-color prev"
                >
                  <img src={greyBackArrowImage} /> Prev
                </div>
              </div>

              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default withRouter(LoginPage);
